<template>
  <div class="main">
    <div>
      <a-form :form="searchForm" @submit="search">
        <a-row class="search" type="flex" align="middle">
          <a-col :span="6">
            <a-form-item label="专题名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
              <a-input :maxLength="20" v-decorator="['name']" />
            </a-form-item>
          </a-col>
          <a-col :span="10" class="button">
            <a-button type="primary" html-type="submit">查询</a-button>
            <a-button @click="reset()">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
      <div>
        <a-table :columns="columns" :rowKey="record => record.specid" :dataSource="data" :pagination="pagination"
          :loading="tableLoading" size="small" @change="handleTableChange">
          <template slot="operation" slot-scope="text, record">
            <a @click="detalis(record.specid)" class="active">查看详情</a>
            <a-popconfirm title="确定要删除么" okText="确定" cancelText="取消" @confirm="del(record.specid)">
              <a-icon slot="icon" type="warning" style="color: red" />
              <a class="active">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'specid',
    key: 'specid'
  },
  {
    title: '专题名称',
    dataIndex: 'catname',
    scopedSlots: { customRender: 'catname' },
    width: '300px'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    with: 400
  }
];
export default {
  data() {
    return {
      columns,
      confirmLoading: false,
      form: this.$form.createForm(this),
      searchForm: this.$form.createForm(this, { name: 'search_from' }),
      param: {
        specname: '',
        page: 1,
        limit: 20
      },
      pagination: {
        pageSize: 20
      },
      tableLoading: false,
      data: [],
      parentid: 0 //为0是建专题，不为0则是子栏目
    };
  },
  methods: {
    search(e) {
      e.preventDefault();
      this.searchForm.validateFields((err, values) => {
        if (!err) {
          this.param.specname = values.name;
          this.getCateList(this.param);
        }
      });
    },
    reset() {
      this.searchForm.resetFields();
    },
    getCateList(param) {
      this.tableLoading = true;
      this.$http
        .post('http://127.0.0.1:8360/api/special/getCate', param)
        .then(res => {
          const pagination = { ...this.pagination };
          if (res.data.errno === 0) {
            this.data = res.data.data.lists;
            pagination.total = res.data.data.total;
          } else {
            pagination.total = 0;
            this.data = [];
          }
          this.tableLoading = false;
          this.pagination = pagination;
        });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.param.page = pagination.current;
      this.pagination = pagination;
      this.getCateList(this.param);
    },
    detalis(specid) {
      this.$router.push('/Main/Thematic/Drag?specid=' + specid);
    },
    del(specid) {
      this.$http
        .post('http://127.0.0.1:8360/api/special/delCate', { specid })
        .then(res => {
          if (res.data.errno === 0) {
            this.$message.success('删除成功');
            this.getCateList(this.param);
          }
        });
    },
    handleEdit() {
      this.$http
        .post('http://127.0.0.1:8360/api/special/updateCate', {
          specid: this.topic.info.specid,
          catname: this.topic.input
        })
        .then(res => {
          if (res.data.errno === 0) {
            this.topicVisible = false;
            this.$message.success('修改成功');
            this.getCateList(this.param);
          }
        });
    }
  },
  created() {
    this.getCateList(this.param);
  }
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}

.search {
  padding-left: 20px;
}

.search>div {
  height: 40px;
  line-height: 40px;
  margin: 30px 0;
}

.search .button {
  text-align: right;
}

.search .button button {
  margin-right: 10px;
}

.active {
  margin-right: 5px;
  color: #40a9ff;
}

.topic-title {
  font-weight: bold;
  font-size: 18px;
}
</style>
